var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16667 14.5V7.5C5.16667 6.85833 5.39514 6.30903 5.85208 5.85208C6.30903 5.39514 6.85833 5.16667 7.5 5.16667H17.0083L14.0042 2.1625L15.6667 0.5L21.5 6.33333L15.6667 12.1667L14.0042 10.5333L17.0083 7.5H7.5V14.5H5.16667ZM2.83333 21.5C2.19167 21.5 1.64236 21.2715 1.18542 20.8146C0.728472 20.3576 0.5 19.8083 0.5 19.1667V1.66667H2.83333V19.1667H16.8333V14.5H19.1667V19.1667C19.1667 19.8083 18.9382 20.3576 18.4813 20.8146C18.0243 21.2715 17.475 21.5 16.8333 21.5H2.83333Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCsv);
export default __webpack_public_path__ + "static/media/share_csv.471c98a7852ab0e022cb5b41a8714615.svg";
export { ForwardRef as ReactComponent };